.resourceInfoOverlay {
    box-shadow: var(--mantine-shadow-lg);
}

.preLineText {
    white-space: pre-line;
}
